import React from 'react';
import AboutMainWrap from "../style/wrap";
import Container from "../../../../components/paper/container";
import SectionTitle from "../../../../components/heading/section";
import {Button, Card, Col, Row, Space} from "antd";
import CardTitle from "../../../../components/heading/card";
import ChartImage1 from '../../../../assets/img/applicants_verify.png'
import styled from "styled-components"
import {Icon} from '@iconify/react';
import AuthLayout from '../../../../layouts/auth.layout';
import P1 from "../../../../components/paragraph";

const AboutMain = () => {
    return (
        <AboutMainWrap>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '0px'}}>  
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                        
                        <Col lg={{span: 20}} span={AuthLayout}>
                            <Space direction='vertical' style={{width: '100%'}} size={32}>
                                <div style={{
                                        position: 'relative',
                                        paddingTop: '0%',
                                    }}>
                                    <a href="tenants/id"><img src={ChartImage1} alt=""/></a>
                                    
                                </div>
                            </Space>
                        </Col>
                        
                        <Col lg={{span: 2}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                </Space>
            </Container>
            <Container>
                <Space direction='vertical' size={32} style={{width: '100%', paddingTop: '0px'}}>  
                    <Row gutter={[32, 32]}>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                        <Col lg={{span: 18}} span={AuthLayout}>
                            <Container>
                                <P1>
                                {/* <h4>Automate</h4> */}
                                {/* <SectionTitle>
                                Apply To Hundreds Of Rentals At Once
                                </SectionTitle> */}
                                <h1 style={{paddingTop: 30, paddingBottom: 0, textAlign: 'center'}}>
                                 {/* MOGUL iCard verifies phone, email, address, ssn, banking, identitiy, biometrics and creates a secure unique profile to use to apply for rentals. */}
                                 Create a secure profile once by verify phone, email, address, ssn, banking, identitiy, biometrics and use again and again to apply for rentals.
                                </h1>
                                </P1>
                            </Container>
                        </Col>
                        <Col lg={{span: 3}} span={AuthLayout}>
                            
                        </Col>
                    </Row>
                </Space>
            </Container>
        </AboutMainWrap>
    );
};

const ActionFormCard = styled(Card)`
  box-shadow: none;
  border: none;
  background: linear-gradient(to top, #f4e1ff, #f4e1ff);
  border-radius: 12px;
  padding: 0px;

  h2 {
    text-align: center;
    //font-size: 28px;
    margin-bottom: 0px;
  }

  h3 {
    font-size: 24px;
    text-align: center;
    margin-bottom: 0px;
  }

  @media (max-width: 768px) {
    padding: 0;
  }
`

export default AboutMain;
